import { render, staticRenderFns } from "./CoverageCard.vue?vue&type=template&id=107dbe7e&"
import script from "./CoverageCard.vue?vue&type=script&lang=js&"
export * from "./CoverageCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports